import { render } from "./CustomTemplate.vue?vue&type=template&id=6c1234e0"
import script from "./CustomTemplate.vue?vue&type=script&lang=js"
export * from "./CustomTemplate.vue?vue&type=script&lang=js"

import "./CustomTemplate.vue?vue&type=style&index=0&id=6c1234e0&lang=css"
script.render = render

export default script